import { useSavedSearchesQuery } from 'src/hooks/__generated__/queries';
import useUser from 'src/hooks/useUser';

export const useSavedSearches = () => {
    const currentUser = useUser();

    const { data, loading, fetchMore } = useSavedSearchesQuery({
        variables: {
            offset: 0,
            limit: 10,
        },
        skip: !currentUser,
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    return {
        savedSearches: data?.savedSearches.results,
        totalSavedSearches: data?.savedSearches.total,
        loading,
        fetchMore,
        hasMore: (data?.savedSearches.results.length ?? 0) < (data?.savedSearches.total ?? 0),
    };
};
